const state = () => ({
	display: false,
	text: '',
	timeout: 2000
});

const getters = {
};

const mutations = {
	setDisplay (state, display) {
		state.display = display;
	},
	setText (state, text) {
		state.text = text;
	}
};

const actions = {};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
